import "../css/Inicio.css";
import Navbar1 from "../components/Navbar1";
import Navbar2 from "../components/Navbar2";
import Panel_Certificados from "../components/Panel_Certificados";
import Footer from "../components/Footer";

export default function Certificados() {
  return (
    <div className="panelPrincipal">
      <Navbar1 />
      <Navbar2 />
      <Panel_Certificados />
      <Footer />
    </div>
  );
}